import { t } from 'i18next';

import { ErrorResponseErrorItemCodeBatchDownload } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeBatchDownload, string> => ({
  'batch_download:no_items': t('batchDownload.noItems', {
    ns: 'apiErrorCodes',
    defaultValue: 'Minst en fil eller mapp måste väljas.',
  }),
  'batch_download:items_not_siblings': t('batchDownload.itemsNotSiblings', {
    ns: 'apiErrorCodes',
    defaultValue: 'Valda filer och mappar måste ha samma föräldermapp.',
  }),
});
